import {
  FormatDateOptions,
  FormatNumberOptions,
  PrimitiveType,
  useIntl,
} from "react-intl";
import { IntlMessageID } from "~/providers/I18nProvider";

export const useLanguage = () => {
  const intl = useIntl();

  const formatNumber = (value: number, options?: FormatNumberOptions) =>
    intl.formatNumber(value, options);

  const formatDate = (value: Date | string, options?: FormatDateOptions) => {
    const tempDate = typeof value === "string" ? new Date(value) : value;

    return intl.formatDate(tempDate, {
      month: "long",
      day: "numeric",
      year: "numeric",
      ...options,
    });
  };

  const formatMessage = (
    id: IntlMessageID,
    variables?: Record<string, PrimitiveType>,
  ): string =>
    intl.formatMessage(
      {
        id,
      },
      variables,
    );

  const formatTime = (value: Date | string, options?: FormatDateOptions) => {
    const tempDate = typeof value === "string" ? new Date(value) : value;

    return intl.formatTime(tempDate, {
      hour: "numeric",
      minute: "numeric",
      ...options,
    });
  };

  return {
    formatNumber,
    formatDate,
    formatMessage,
    formatTime,
  };
};
